import * as Dtos from '../../dtos/Tmd.dtos';
import { IFieldState, IRegistrationFormState } from "./index";

export const initialTrialInstitutionItemTemplateState: Dtos.TrialInstitutionItemTemplate & IRegistrationFormState = {
    id: null,
    name: null,
    description: null,
    rank: null,
    trialInstitutionItemTemplateCategoryId: null,
    trialInstitutionItemTemplateCategory: null,
    trialId: null,
    trial: null,
    allowIntraVersions: null,
    pendingDelete: null,
    allowVersionChanges: null,
    initialVersion: null,
    collectionId: null,
    collection: null,
    active: null,
    dateEntered: null,
    dateModified: null,
    enteredBy: null,
    modifiedBy: null,
    saveAndReturn: false,
}

export interface ITrialInstitutionItemTemplateReduxFormState {
    id: IFieldState<number>,
    name: IFieldState<string>,
    description: IFieldState<string>,
    rank: IFieldState<number>,
    trialInstitutionItemTemplateCategoryId: IFieldState<number>,
    trialId: IFieldState<number>,
    allowIntraVersions: IFieldState<boolean>,
    initialVersion: IFieldState<string>,
    collectionId: IFieldState<number>,
    active: IFieldState<boolean>,
    dateEntered: IFieldState<string>,
    dateModified: IFieldState<string>,
    enteredBy: IFieldState<string>,
    modifiedBy: IFieldState<string>,
    message: IFieldState<string>,
    openedModals: IFieldState<string[]>
}
